export default {
  baseApiUrl: 'https://www.breakingbadapi.com/api/',
};
